"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReviewReportedTravelTime = void 0;
const react_1 = __importStar(require("react"));
const components_1 = require("../../../../components");
const Flex_1 = require("@amzn/atoz-web/Flex");
const Text_1 = require("@amzn/atoz-web/Text");
const View_1 = require("@amzn/atoz-web/View");
const Hr_1 = require("@amzn/atoz-web/Hr");
const react_i18next_1 = require("react-i18next");
const context_1 = require("../../../../components/UnscheduledWorkWorkflow/context");
const utils_1 = require("../../../../utils");
const logger_1 = require("../../../../logger");
const ReviewReportedTravelTime = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { travelStartTime, travelStartDate, travelEndTime, travelEndDate, isSubmitting, setIsCurrentStepValid, setIsActionable, setCurrentStepTitle, duration, isMealBreakApplicable, mealBreakStartTime, mealBreakEndTime, reasonForTravel } = (0, context_1.useUnscheduledWorkflowContext)();
    (0, logger_1.useComponentLoadedMetrics)({
        metricNames: {
            countMetricName: logger_1.METRICS.REPORT_TRAVEL_TIME_REVIEW_PAGE_RENDERED.COUNT
        },
        isComponentLoaded: true
    });
    (0, react_1.useEffect)(() => {
        utils_1.BIAnalytics.arriveReportTravelTimeReviewStepInRTTW();
        setCurrentStepTitle(t('unscheduled_work_report_travel_review_heading'));
        setIsActionable(true);
        setIsCurrentStepValid(true);
    }, []);
    return (react_1.default.createElement(Flex_1.Flex, { flexDirection: 'column', dataTestId: components_1.UNSCHEDULED_WORK_WF_DATA_TEST_IDS.REVIEW_REPORTED_TRAVEL_TIME_CONTAINER },
        react_1.default.createElement(components_1.SpinnerOverlay, { isLoading: isSubmitting },
            react_1.default.createElement(Flex_1.Flex, { flexDirection: 'column', gridGap: 'S300', margin: { top: 'S300' } },
                react_1.default.createElement(Text_1.H2, { fontSize: 'T400', fontWeight: 500 }, `${t('unscheduled_work_report_travel_start_time')} :`),
                react_1.default.createElement(Text_1.Text, { fontSize: 'T300', color: 'neutral90' }, t('time_and_attendance_DateAtTime', {
                    date: travelStartDate === null || travelStartDate === void 0 ? void 0 : travelStartDate.toFormat('LLLL dd, yyyy'),
                    time: travelStartTime
                }))),
            react_1.default.createElement(Flex_1.Flex, { flexDirection: 'column', gridGap: 'S300', margin: { top: 'S300' } },
                react_1.default.createElement(Text_1.H2, { fontSize: 'T400', fontWeight: 500 }, `${t('unscheduled_work_report_travel_end_time')} :`),
                react_1.default.createElement(Text_1.Text, { fontSize: 'T300', color: 'neutral90' }, t('time_and_attendance_DateAtTime', {
                    date: travelEndDate === null || travelEndDate === void 0 ? void 0 : travelEndDate.toFormat('LLLL dd, yyyy'),
                    time: travelEndTime
                }))),
            isMealBreakApplicable && mealBreakStartTime && mealBreakEndTime && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Flex_1.Flex, { dataTestId: components_1.UNSCHEDULED_WORK_WF_DATA_TEST_IDS.MEAL_BREAK_IN_REVIEW_PAGE, flexDirection: 'column', gridGap: 'S300', margin: { top: 'S300' } },
                    react_1.default.createElement(Text_1.H2, { fontSize: 'T400', fontWeight: 500 }, `${t('unscheduled_work_report_travel_review_Meal_break_start_time')} :`),
                    react_1.default.createElement(Text_1.Text, { fontSize: 'T300', color: 'neutral90' }, mealBreakStartTime)),
                react_1.default.createElement(Flex_1.Flex, { flexDirection: 'column', gridGap: 'S300', margin: { top: 'S300' } },
                    react_1.default.createElement(Text_1.H2, { fontSize: 'T400', fontWeight: 500 }, `${t('unscheduled_work_report_travel_review_Meal_break_end_time')} :`),
                    react_1.default.createElement(Text_1.Text, { fontSize: 'T300', color: 'neutral90' }, mealBreakEndTime)))),
            react_1.default.createElement(Flex_1.Flex, { flexDirection: 'column', gridGap: 'S300', margin: { top: 'S300' } },
                react_1.default.createElement(Text_1.H2, { fontSize: 'T400', fontWeight: 500 }, `${t('unscheduled_work_report_travel_duration')} :`),
                react_1.default.createElement(Text_1.Text, { fontSize: 'T300', color: 'neutral90' }, `${(0, components_1.getHoursAndMinutesFromDuration)(duration)}`)),
            react_1.default.createElement(Flex_1.Flex, { flexDirection: 'column', gridGap: 'S300', margin: { top: 'S300' } },
                react_1.default.createElement(Text_1.H2, { fontSize: 'T400', fontWeight: 500 }, `${t('unscheduled_work_report_travel_reason_for_travel_label')} :`),
                react_1.default.createElement(Text_1.Text, { fontSize: 'T300', color: 'neutral90' }, reasonForTravel)),
            react_1.default.createElement(View_1.View, { margin: { top: 'S400' } },
                react_1.default.createElement(Hr_1.Hr, null)))));
};
exports.ReviewReportedTravelTime = ReviewReportedTravelTime;
